/* eslint-disable */
import { useRef, useState, useEffect } from 'react';
import useBoundingClientRect from './useBoundingClientRect';

export const createMouseEvent = (evt, rect) => ({
	x: evt.x || 0,
	y: evt.y || 0,
	pageX: evt.pageX || 0,
	pageY: evt.pageY || 0,
	clientX: evt.clientX || 0,
	clientY: evt.clientY || 0,
	screenX: evt.screenX || 0,
	screenY: evt.screenY || 0,
	elementWidth: evt.elementWidth || 0,
	elementHeight: evt.elementHeight || 0,
	isOver: evt.isOver || false,
	isDown: evt.isDown || false,
	rect,
});

export function useCursorPosition() {
	const [ref, rect] = useBoundingClientRect();
	const [info, setInfo] = useState(createMouseEvent({}, rect));

	const handleMouseMove = (evt) => {
		const stageX = window.pageXOffset || window.scrollX;
		const stageY = window.pageYOffset || window.scrollY;
		const mouseInfo = createMouseEvent(evt, rect);
		mouseInfo.x = mouseInfo.pageX - rect.left - stageX;
		mouseInfo.y = mouseInfo.pageY - rect.top - stageY;
		setInfo(mouseInfo);
	};

	useEffect(() => {
		setInfo(createMouseEvent({}, rect));
		document.addEventListener('pointermove', handleMouseMove, true);
		return () => {
			document.removeEventListener('pointermove', handleMouseMove, true);
		};
	}, [ref.current]);

	return [ref, info];
}

export default useCursorPosition;
